module.exports = __webpack_public_path__ + "static/media/YB5F06_0.7144dbc0.jpg";